import { h, Component } from 'preact';
import Beans3 from '@/beans';
import { i18n, Utils } from '@/base/helpers';
import { ActionModalHeader, Overlay } from '../../components';

export default class Leaderboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shopper: {
        beans_member_id: props.account.id,
        pseudonym: '',
      },
      loading: false,
      isSaved: false,
      message: {
        text: '',
        color: Utils.BeansStatusColor.default.color,
      },
    };
  }

  componentDidMount() {
    const { account } = this.props;

    const fetchShopperData = async () => {
      try {
        const res = await Beans3.get({ path: `leaderboard/shopper/${account.id}/`, namespace: 'trellis' });
        if (res) {
          this.setState({ shopper: res, loading: false });
        }
      } catch (error) {
        this.setState({ loading: false });
      }
    };

    fetchShopperData();
  }

  handlePseudonymSave = async () => {
    const { shopper } = this.state;
    const { account } = this.props;
    const pseudonym = shopper.pseudonym;

    if (!pseudonym || pseudonym.length < 3 || pseudonym.length > 20) {
      this.setState({
        message: {
          text: i18n.t('leaderboard', 'pseudonym_required_error'),
          color: Utils.BeansStatusColor.error.color,
        },
      });
      return;
    }

    this.setState({ loading: true, isSaved: false });

    try {
      if (shopper.id) {
        await Beans3.put({
          path: `leaderboard/shopper/${account.id}/`,
          namespace: 'trellis',
          data: { pseudonym },
        });
      } else {
        const data = await Beans3.post({
          path: 'leaderboard/shopper/',
          namespace: 'trellis',
          data: {
            beans_member_id: account.id,
            pseudonym,
          },
        });
        this.setState({ shopper: data });
      }

      this.setState((prevState) => ({
        shopper: { ...prevState.shopper, pseudonym },
        loading: false,
        isSaved: true,
        message: {
          text: i18n.t('leaderboard', 'pseudonym_saved_success'),
          color: Utils.BeansStatusColor.done.color,
        },
      }));
      window.location.reload(); // Reload the page to reflect the changes
    } catch (error) {
      this.setState({
        isSaved: false,
        message: {
          text: i18n.t('leaderboard', 'pseudonym_save_error'),
          color: Utils.BeansStatusColor.error.color,
        },
      });
    }
  };

  handleInputChange = (e) => {
    const pseudonym = e.target.value;
    this.setState((prevState) => ({
      shopper: { ...prevState.shopper, pseudonym },
    }));
  };

  render() {
    const { loading, shopper } = this.state;
    const disabledStyle = loading ? { opacity: 0.8, cursor: 'wait' } : {};

    return (
      <Overlay isOpen={this.props.isOpen} onClose={() => this.props.onClose()}>
        <div className="liana-rule-action-modal" id="liana-modal-leaderboard">
          <ActionModalHeader
            headerTitle={i18n.t('leaderboard', 'set_pseudonym')}
            closeTab={() => this.props.onClose()}
          />
          <div className="liana-action-modal-body">
            <div className="liana-modal-body-content-wrapper">
              <div className="beans-text beans-text-secondary">{i18n.t('leaderboard', 'pseudonym_info')}</div>
              <div className="liana-action-modal-input-wrapper">
                <div className="beans-text beans-text-bold beans-text-secondary">
                  {i18n.t('leaderboard', 'pseudonym')}
                </div>
                <input
                  type="text"
                  id="pseudonym-input"
                  name="pseudonym"
                  required
                  value={shopper ? shopper.pseudonym : ''}
                  onChange={this.handleInputChange}
                />
                {this.state.message.text && (
                  <div className="beans-text" style={{ color: this.state.message.color }}>
                    {this.state.message.text}
                  </div>
                )}
              </div>
              <div
                tabIndex={0}
                role="button"
                className="beans-button beans-button-primary"
                style={disabledStyle}
                onClick={this.handlePseudonymSave}
              >
                {loading ? i18n.t('leaderboard', 'saving') : i18n.t('actions', 'save')}
              </div>
            </div>
          </div>
        </div>
      </Overlay>
    );
  }
}
